<div class="input-container tw-flex tw-justify-between tw-items-center">
  <section class="tw-flex tw-items-center">
    <mg-text
      *ngIf="label"
      variant="body-md">
      {{ label }}
    </mg-text>
    <mg-tooltip
      *ngIf="tooltip"
      [label]="tooltip">
    </mg-tooltip>
  </section>

  <fieldset class="relative-time-inputs tw-flex">
    <!-- Time Value -->
    <mg-form-text-input
      class="time-value-input"
      inputType="number"
      placeholder="1"
      [control]="form.controls.timeValue">
    </mg-form-text-input>

    <!-- Time Unit (hours/minutes) -->
    <mg-form-select
      class="time-unit-input time-select-input"
      [floatingLabel]="false"
      [condensed]="true"
      [options]="TIME_UNIT_OPTIONS"
      [control]="form.controls.timeUnit">
    </mg-form-select>

    <!-- Time Direction (before/after) -->
    <mg-form-select
      class="time-direction-input time-select-input"
      [floatingLabel]="false"
      [condensed]="true"
      [options]="TIME_DIRECTION_OPTIONS"
      [control]="form.controls.timeDirection">
    </mg-form-select>
  </fieldset>
</div>
